var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"h5-nav-min-page"},[_c('span',[_vm._v("登录获取更多求职招聘信息！")]),_c('div',{staticClass:"right-brn",on:{"click":_vm.toMiniProFun}},[_vm._v("登录/注册")])])
}
var staticRenderFns = []

export { render, staticRenderFns }